{
    "general": {
        "back": "Retour",
        "cancel": "Annuler",
        "close": "Fermer",
        "ok": "Ok",
        "next": "Suivant",
        "languages": {
            "en": "English",
            "fr": "Français"
        }
    },
    "forms": {
        "errors": {
            "required": "{{field}} est requis.",
            "email": "{{field}} n'est pas une adresse e-mail valide.",
            "minlength": "{{field}} doit contenir au moins {{requiredLength}} caractères.",
            "maxlength": "{{field}} ne peut pas dépasser {{requiredLength}} caractères.",
            "min": "{{field}} doit être au moins {{min}}.",
            "max": "{{field}} ne peut pas dépasser {{max}}.",
            "pattern": "{{field}} a un format invalide.",
            "invalid": "{{field}} est invalide.",
            "minSelected": "Veuillez en sélectionner au moins {{required}}."
        }
    },
    "shared": {
        "grid": {
            "loading": "Chargement...",
            "pageReport": "Affichage de {first} à {last} sur {totalRecords}",
            "locale": {
                "loadingOoo": "Chargement...",
                "loadingError": "Erreur",
                "noRowsToShow": "Aucune ligne à afficher",
                "empty": "Choisir une option",
                "blanks": "(Vides)",
                "true": "Vrai",
                "false": "Faux",
                "contains": "Contient",
                "notContains": "Ne contient pas",
                "equals": "Égal à",
                "notEqual": "Différent de",
                "startsWith": "Commence par",
                "endsWith": "Termine par",
                "lessThan": "Inférieur à",
                "greaterThan": "Supérieur à",
                "lessThanOrEqual": "Inférieur ou égal à",
                "greaterThanOrEqual": "Supérieur ou égal à",
                "inRange": "Entre",
                "inRangeStart": "De",
                "inRangeEnd": "À",
                "blank": "Vide",
                "notBlank": "Non vide",
                "before": "Avant",
                "after": "Après",
                "filterOoo": "Filtrer...",
                "searchOoo": "Rechercher...",
                "applyFilter": "Appliquer",
                "resetFilter": "Réinitialiser",
                "clearFilter": "Effacer",
                "cancelFilter": "Annuler",
                "selectAll": "(Tout sélectionner)",
                "selectAllSearchResults": "(Tout sélectionner dans les résultats)",
                "noMatches": "Aucun résultat",
                "andCondition": "ET",
                "orCondition": "OU",
                "sortAscending": "Tri croissant",
                "sortDescending": "Tri décroissant",
                "sortUnSort": "Annuler le tri",
                "pinColumn": "Épingler la colonne",
                "pinLeft": "Épingler à gauche",
                "pinRight": "Épingler à droite",
                "noPin": "Ne pas épingler",
                "autosizeThiscolumn": "Ajuster cette colonne",
                "autosizeAllColumns": "Ajuster toutes les colonnes",
                "resetColumns": "Réinitialiser les colonnes",
                "expandAll": "Tout développer",
                "collapseAll": "Tout réduire"
            }
        }
    },
    "header": {
        "userMenu": {
            "settings": "Paramètres",
            "darkMode": "Mode sombre",
            "developerMode": "Mode développeur",
            "signOut": "Se déconnecter",
            "exit": "Quitter"
        },
        "uploadProgress": {
            "indicator": {
                "toggleAriaLabel": "Afficher les détails du téléversement"
            },
            "title": {
                "inProgress": "Téléversement en cours…",
                "completed": "Téléversement terminé",
                "partialFailure": "Téléversement terminé avec des erreurs"
            },
            "hideAriaLabel": "Masquer la progression du téléversement",
            "summary": {
                "completed": "{{completed}} / {{total}} terminés",
                "failed": "{{failed}} échoués"
            },
            "fileStatus": {
                "pending": "En file",
                "inProgress": "Chiffrement…",
                "completed": "Terminé",
                "failed": "Échec",
                "preparing": "Préparation…",
                "sharing": "Envoi vers le partage sécurisé…",
                "overall": "Global",
                "archiveFile": "Fichier {{index}} sur {{total}}",
                "rows": "{{count}} lignes",
                "slow": "Plus long que prévu…"
            },
            "connection": {
                "reconnecting": "Reconnexion…",
                "lost": "Connexion perdue. Nouvelle tentative…"
            },
            "noErrorDetail": "Aucun détail d'erreur disponible.",
            "dismiss": "Fermer",
            "dismissAriaLabel": "Fermer le téléversement",
            "sessionExpired": {
                "summary": "Session expirée",
                "detail": "Votre session a expiré pendant le traitement. Reconnectez-vous et utilisez Réessayer pour les fichiers en échec."
            }
        }
    },
    "sidebar": {
        "pages": {
            "workPackages": "Lots de travail",
            "inbox": "Boîte de réception"
        },
        "categories": {
            "activeWorkPackages": "Lots de travail actifs"
        },
        "statusCard": {
            "title": "État du système",
            "statuses": {
                "online": "En ligne",
                "unverified": "Vérification impossible"
            }
        }
    },
    "splash": {
        "starting": "Démarrage du service Privanot…",
        "startingAttempt": "Démarrage du service Privanot (tentative {{attempt}})",
        "connecting": "Connexion au service Privanot...",
        "tunnelConnecting": "Établissement d'une connexion sécurisée…",
        "tunnelTimeout": "La connexion sécurisée prend plus de temps que prévu. Veuillez réessayer.",
        "serviceFailed": "Le service Privanot n'a pas pu démarrer.",
        "error": "Impossible de se connecter au service Privanot.",
        "unauthorized": "Vous n'êtes pas autorisé à vous connecter au service Privanot.",
        "retry": "Réessayer",
        "closeApp": "Fermer l'application"
    },
    "errors": {
        "websocket": {
            "summary": "Erreur du serveur",
            "unknown": "Une erreur inattendue s'est produite."
        },
        "file": {
            "sessionExpired": "Session expirée : reconnectez-vous et utilisez Réessayer pour les fichiers en échec"
        }
    },
    "features": {
        "settings": {
            "title": "Paramètres",
            "sharingKey": {
                "title": "Clés de partage",
                "emptyBody": "Vous n'avez pas encore de clés de partage. Les fichiers partagés avec vous ne peuvent pas être reçus tant que vous ne les avez pas enregistrées.",
                "registered": {
                    "title": "Enregistrées",
                    "encryptionKey": "Clé de chiffrement",
                    "at": "Enregistrées le"
                },
                "generate": {
                    "tab": "Générer",
                    "description": "Générez une nouvelle paire de clés de chiffrement RSA-4096. La clé privée est stockée de façon sécurisée uniquement sur cet appareil — il n'y a pas de sauvegarde.",
                    "button": "Générer les clés",
                    "confirmHeader": "Générer les clés de partage ?",
                    "confirmBody": "Êtes-vous sûr de vouloir générer de nouvelles clés de partage ? Cet appareil sera votre seul récepteur pour les fichiers partagés."
                },
                "import": {
                    "tab": "Importer",
                    "description": "Collez votre clé privée de chiffrement existante au format PEM RSA-4096.",
                    "encryptionPemLabel": "Clé de chiffrement (PEM)",
                    "encryptionPemPlaceholder": "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
                    "button": "Importer les clés"
                },
                "toastGenerated": "Clés de partage générées",
                "toastImported": "Clés de partage importées",
                "toastExportGenerated": "Clés de partage générées. Copiez-les avant de quitter cette page.",
                "hostedGenerate": {
                    "button": "Générer les clés",
                    "confirmHeader": "Générer les clés de partage ?",
                    "confirmBodyPrimary": "Une nouvelle paire de clés de chiffrement RSA-4096 sera générée. Rien ne change tant que vous n'avez pas remplacé la valeur EncryptionKey dans la configuration du service et redémarré le service.",
                    "confirmBodySecondary": "Avant de redémarrer le service avec la nouvelle clé, demandez à votre administrateur de révoquer votre clé actuellement enregistrée. Sinon, la nouvelle clé ne sera pas enregistrée et les fichiers partagés avec vous ne pourront pas être déchiffrés.",
                    "resultWarning": "Cette clé n'est affichée qu'une seule fois. Copiez-la maintenant, vous ne pourrez pas la récupérer plus tard.",
                    "encryptionKeyLabel": "Clé de chiffrement",
                    "encryptionFingerprintLabel": "Empreinte de la clé de chiffrement",
                    "copy": "Copier",
                    "copied": "Copié"
                },
                "loadFailedBanner": "Vos clés de chiffrement n'ont pas pu être chargées sur cet appareil. Les partages passés sont définitivement inaccessibles. Générez une nouvelle paire pour recevoir les futurs partages.",
                "loadFailedBannerLink": "Générer maintenant",
                "hostedManagedTitle": "Géré par votre administrateur",
                "hostedManagedBody": "Les clés de partage de cet espace de travail sont provisionnées de manière centralisée. Contactez votre administrateur pour les faire tourner ou les remplacer.",
                "hostedLoadFailedBanner": "Clés de partage indisponibles. Contactez votre administrateur.",
                "revoked": {
                    "title": "Accès de partage révoqué",
                    "body": "Votre administrateur a révoqué votre accès de partage. Vous ne recevrez plus de nouveaux fichiers partagés tant qu'il n'est pas rétabli. Contactez votre administrateur.",
                    "panelTitle": "Révoqué",
                    "at": "Révoqué le"
                },
                "localOnly": {
                    "title": "Pas encore enregistré auprès de votre administrateur",
                    "body": "Les clés existent sur cet appareil mais l'administrateur ne les a pas encore confirmées. Le partage est indisponible tant que l'enregistrement n'est pas terminé.",
                    "panelTitle": "En attente d'enregistrement"
                },
                "mismatch": {
                    "banner": "Votre clé de partage ne correspond pas à celle enregistrée auprès de votre administrateur. Les fichiers partagés avec vous ne peuvent pas être déchiffrés.",
                    "bannerLink": "Voir les détails",
                    "title": "Clé de partage non concordante",
                    "body": "La clé de cet appareil n'est pas celle enregistrée par votre administrateur, les fichiers partagés avec vous ne peuvent donc pas être déchiffrés. Générez de nouvelles clés pour enregistrer à nouveau cet appareil. Les fichiers déjà partagés avec l'ancienne clé devront être partagés à nouveau.",
                    "hostedBody": "La valeur EncryptionKey de la configuration du service n'est pas la clé enregistrée par votre administrateur, les fichiers partagés avec vous ne peuvent donc pas être déchiffrés. Restaurez la clé correspondante dans la configuration, ou demandez à votre administrateur de révoquer la clé enregistrée puis redémarrez le service. Si la clé enregistrée est révoquée, les fichiers déjà partagés avec elle devront être partagés à nouveau.",
                    "panelTitle": "Clé non concordante",
                    "registeredKey": "Enregistrée auprès de l'administrateur"
                }
            }
        },
        "workPackages": {
            "title": "Lots de travail",
            "assignedList": {
                "active": "Lots de travail actifs",
                "archived": "Lots de travail archivés"
            },
            "dashboard": {
                "fields": {
                    "createdAt": "Créé le"
                },
                "status": {
                    "active": "Actif",
                    "archived": "Archivé"
                },
                "noFilesUploadedYet": {
                    "title": "Lot de travail vide",
                    "description": "Aucun fichier n'a encore été téléversé dans ce lot de travail.",
                    "action": "Initialiser le lot de travail"
                },
                "metrics": {
                    "numFiles": "Nombre de fichiers",
                    "encryptedColumns": "Colonnes chiffrées",
                    "rowsEncrypted": "Lignes chiffrées",
                    "encryptionCoverage": "Couverture du chiffrement",
                    "filesProcessed": "Fichiers traités",
                    "rowsProcessed": "Total des lignes traitées",
                    "filesDelivered": "Fichiers livrés au SFTP",
                    "complete": "Complet",
                    "inProgress": "En cours"
                },
                "pipeline": {
                    "title": "État du pipeline",
                    "completedCount": "{{completed}}/{{total}} terminé",
                    "stages": {
                        "schema": "Schéma",
                        "mapping": "Mappage",
                        "encryption": "Chiffr.",
                        "pseudonymization": "Pseudo.",
                        "output": "Sortie"
                    }
                },
                "fileDetails": {
                    "title": "Détails du fichier",
                    "fileName": "Nom du fichier",
                    "fileSize": "Taille du fichier",
                    "rows": "Lignes",
                    "columnsSelected": "Colonnes sélectionnées",
                    "status": "Statut",
                    "error": "Erreur",
                    "startedAt": "Démarré le",
                    "completedAt": "Terminé le",
                    "duration": "Durée"
                },
                "operationDetails": {
                    "title": "Détails de l'opération",
                    "name": "Nom",
                    "status": "Statut",
                    "createdAt": "Créé le",
                    "startedAt": "Démarré le",
                    "completedAt": "Terminé le",
                    "duration": "Durée",
                    "files": "Fichiers",
                    "recipients": "Partagé avec",
                    "noRecipients": "Non partagé avec d'autres clients"
                },
                "operations": {
                    "title": "Opérations",
                    "uploadNewFile": "Téléverser un nouveau fichier",
                    "addFile": "Ajouter un fichier",
                    "refresh": "Actualiser",
                    "table": {
                        "operationLabel": "Opération",
                        "loading": "Chargement...",
                        "headers": {
                            "name": "Nom",
                            "fileSize": "Taille",
                            "rowCount": "Lignes",
                            "columnsSelectedCount": "Colonnes sélectionnées",
                            "duration": "Durée",
                            "status": "Statut",
                            "sharedWith": "Partagé avec"
                        },
                        "operationStatus": {
                            "queued": "En file",
                            "running": "En cours",
                            "succeeded": "Réussi",
                            "partialSuccess": "Succès partiel",
                            "failed": "Échec"
                        },
                        "shareStatus": {
                            "uploadPending": "Téléversement en attente",
                            "uploaded": "Téléversé",
                            "completed": "Terminé",
                            "expired": "Expiré",
                            "failed": "Échec",
                            "notSent": "Non envoyé",
                            "description": {
                                "uploadPending": "En attente du téléversement du fichier chiffré vers l'emplacement partagé",
                                "uploaded": "Le fichier partagé est prêt à être téléchargé par le destinataire",
                                "completed": "Téléchargé par le destinataire",
                                "expired": "Expiré avant que le destinataire ait pu le télécharger",
                                "notSent": "Non envoyé car un fichier a échoué. Réessayez les fichiers en échec pour l'envoyer."
                            },
                            "failureReason": {
                                "target_client_encryption_key_not_valid": "La clé de chiffrement du destinataire n'est pas configurée ou n'est plus valide",
                                "sender_upload_failed": "Le fichier chiffré n'a pas pu être téléversé",
                                "recipient_revoked": "L'accès de partage du destinataire a été révoqué",
                                "default": "Échec du partage du fichier avec ce destinataire"
                            }
                        },
                        "fileStatus": {
                            "queued": "En file",
                            "running": "Chiffrement",
                            "succeeded": "Réussi",
                            "failed": "Échec"
                        },
                        "actions": {
                            "download": "Télécharger",
                            "moreDetails": "Détails",
                            "retry": "Réessayer",
                            "retryUploadActive": "Attendez la fin du téléversement en cours"
                        }
                    }
                }
            },
            "upload": {
                "emptyState": {
                    "title": "Choisissez les fichiers à pseudonymiser",
                    "description": "Formats de fichiers autorisés : csv, xlsx, zip, tar.gz",
                    "action": "Choisir des fichiers"
                },
                "selection": {
                    "heading": "Choisissez les fichiers à pseudonymiser",
                    "filterPlaceholder": "Rechercher fichiers et dossiers...",
                    "corruptArchive": "corrompu — illisible",
                    "rescan": "Relancer l'analyse",
                    "empty": "Aucun document trouvé"
                },
                "columns": {
                    "heading": "Sélectionnez les colonnes à pseudonymiser pour chaque fichier sélectionné"
                },
                "steps": {
                    "select": {
                        "label": "Sélectionner les documents",
                        "instruction": "Choisissez les fichiers à pseudonymiser."
                    },
                    "configure": {
                        "label": "Configurer les colonnes",
                        "instruction": "Sélectionnez au moins une colonne à pseudonymiser pour chaque fichier."
                    },
                    "share": {
                        "label": "Partager avec des clients",
                        "instruction": "Partagez éventuellement cette opération avec d'autres clients du lot de travail."
                    },
                    "review": {
                        "label": "Vérifier et confirmer",
                        "instruction": "Nommez l'opération et vérifiez les détails avant le téléversement."
                    }
                },
                "share": {
                    "emptyState": "Aucun autre client n'est assigné à ce lot de travail.",
                    "loading": "Chargement des clients…",
                    "loadError": "Impossible de charger les clients de ce lot de travail. Veuillez réessayer.",
                    "expiry": {
                        "ariaLabel": "Expiration du partage",
                        "presets": {
                            "day1": "1 jour",
                            "day3": "3 jours",
                            "day7": "7 jours",
                            "day30": "30 jours"
                        }
                    }
                },
                "review": {
                    "operationName": "Nom de l'opération",
                    "fileCount": "Fichiers",
                    "sharedWith": "Partagé avec",
                    "sharedWithNobody": "Partagé avec aucun autre client",
                    "notSet": "Non défini",
                    "stats": {
                        "files": "Fichiers",
                        "totalSize": "Taille totale",
                        "recipients": "Destinataires"
                    },
                    "preflight": {
                        "title": "Liste de vérification",
                        "nameSet": "Nom de l'opération défini",
                        "columnsConfigured": "Tous les fichiers ont des colonnes configurées ({{configured}} sur {{total}})",
                        "recipientsShared": "Partagé avec {{count}} destinataire(s)",
                        "uploadInProgress": "Un téléversement est déjà en cours"
                    },
                    "manifest": {
                        "title": "Liste des fichiers",
                        "itemCount": "{{count}} éléments",
                        "expand": "Développer",
                        "collapse": "Réduire",
                        "typeDocument": "document",
                        "typeArchive": "archive",
                        "mappedColumns": "{{count}} colonnes mappées",
                        "archiveEntries": "{{mapped}} sur {{total}} entrées mappées"
                    }
                },
                "configuredCount": "{{configured}} sur {{total}} fichiers configurés",
                "operationName": {
                    "label": "Nom de l'opération",
                    "placeholder": "ex. lot d'intégration T3"
                },
                "warnings": {
                    "allFilesNeedColumns": "Tous les fichiers doivent avoir des colonnes sélectionnées pour continuer.",
                    "uploadInProgress": "Un téléversement est déjà en cours. Veuillez attendre la fin avant d'en démarrer un autre."
                },
                "actions": {
                    "editSelection": "Modifier la sélection",
                    "confirmAndAddToWorkPackage": "Confirmer et ajouter au lot de travail"
                },
                "table": {
                    "headers": {
                        "fileName": "Nom du fichier",
                        "fileSize": "Taille",
                        "filePath": "Chemin",
                        "selectedColumns": "Colonnes sélectionnées",
                        "actions": "Actions"
                    },
                    "actions": {
                        "selectColumns": "Sélectionner les colonnes",
                        "modifyColumns": "Modifier les colonnes"
                    },
                    "emptyMessage": "Veuillez sélectionner les fichiers à téléverser",
                    "archiveSummary": "{{configured}} sur {{total}} fichiers configurés",
                    "fileStatus": {
                        "noColumnsSelected": "Aucune colonne sélectionnée",
                        "archiveHasUnconfiguredFiles": "Tous les fichiers de cette archive n'ont pas été configurés.",
                        "analyzing": "Analyse de la structure du fichier...",
                        "analysisFailed": "Impossible d'analyser le fichier"
                    }
                },
                "columnSelection": {
                    "title": "Sélectionner les colonnes à pseudonymiser",
                    "description": "Choisissez les colonnes contenant des données personnelles à pseudonymiser.",
                    "searchPlaceholder": "Rechercher des colonnes...",
                    "columnNameHeader": "Nom de colonne",
                    "selectAllSuggested": "Tout sélectionner (suggérés)",
                    "noSuggestedColumns": "Aucune colonne suggérée trouvée.",
                    "suggestedBadge": "Suggéré",
                    "selectedCount": "{{count}} colonnes sélectionnées",
                    "confirm": "Confirmer la sélection",
                    "noResults": "Aucune colonne ne correspond à votre recherche."
                },
                "retry": {
                    "notice": "Sélectionnez à nouveau le fichier source et les colonnes. Les fichiers seront retraités dans l'opération existante.",
                    "noCandidates": "Aucun fichier correspondant n'a été trouvé dans le dossier de téléversement pour : {{files}}"
                }
            }
        },
        "inbox": {
            "title": "Boîte de réception",
            "subtitle": "Les fichiers partagés avec vous arrivent ici. Cliquez sur télécharger pour écrire un partage dans votre stockage de destination.",
            "actions": {
                "refresh": "Actualiser",
                "downloadAll": "Tout télécharger"
            },
            "empty": {
                "title": "Aucun partage en attente",
                "body": "Lorsqu'un autre client vous partagera une opération, elle apparaîtra ici."
            },
            "counter": "{{count}} partage(s) en attente",
            "pending": {
                "title": "En attente"
            },
            "history": {
                "title": "Partages passés",
                "subtitle": "Partages téléchargés et expirés de la dernière période de rétention.",
                "counter": "{{count}} partage(s) passé(s)",
                "empty": {
                    "title": "Aucun partage passé",
                    "body": "Une fois qu'un partage a été téléchargé ou expire, il apparaîtra ici."
                },
                "actions": {
                    "refresh": "Actualiser l'historique"
                },
                "headers": {
                    "downloaded": "Téléchargé le",
                    "expiredAt": "Expiré le"
                }
            },
            "status": {
                "delivered": "Téléchargé",
                "completed": "Terminé",
                "expired": "Expiré",
                "failed": "Échec"
            },
            "table": {
                "headers": {
                    "files": "Fichiers",
                    "sender": "Expéditeur",
                    "operation": "Opération",
                    "received": "Reçu le",
                    "status": "Statut"
                },
                "status": {
                    "pending": "En attente",
                    "downloadingWithPercent": "Téléchargement {{percent}}%"
                },
                "actions": {
                    "download": "Télécharger",
                    "downloading": "Téléchargement…",
                    "downloaded": "Téléchargé"
                }
            },
            "toast": {
                "received": {
                    "summary": "Nouveau partage reçu",
                    "detail": "{{sender}} vous a partagé « {{operation}} »."
                },
                "failed": {
                    "summary": "Échec du téléchargement",
                    "detail": "Le partage n'a pas pu être téléchargé."
                }
            }
        },
        "fileUpload": {
            "action": "Téléverser un fichier",
            "dialog": {
                "title": "Téléverser un fichier vers votre stockage",
                "description": "Le fichier est envoyé au serveur de stockage de votre organisation et peut ensuite être utilisé dans n'importe quel lot de travail.",
                "choose": "Choisir un fichier",
                "accepted": "Formats acceptés : CSV, XLSX, ZIP, TAR.GZ, TGZ",
                "upload": "Téléverser",
                "uploading": "Téléversement de {{fileName}}…",
                "uploadAnother": "Téléverser un autre fichier",
                "retry": "Réessayer",
                "success": "{{fileName}} a été téléversé. Il est disponible dans « Sélectionner les documents » de chaque lot de travail après « Relancer l'analyse ».",
                "failed": "{{fileName}} n'a pas pu être téléversé."
            },
            "errors": {
                "invalid_name": "Ce nom de fichier ne peut pas être utilisé. Renommez le fichier et réessayez.",
                "unsupported_type": "Ce type de fichier n'est pas pris en charge. Utilisez CSV, XLSX, ZIP, TAR.GZ ou TGZ.",
                "too_large": "Le fichier dépasse la taille maximale autorisée.",
                "already_exists": "Un fichier portant ce nom existe déjà sur votre stockage. Renommez le fichier et réessayez.",
                "storage_unreachable": "Votre serveur de stockage est injoignable. Vérifiez le serveur ou contactez votre administrateur.",
                "storage_auth_failed": "Votre serveur de stockage a refusé les identifiants de connexion. Contactez votre administrateur.",
                "write_denied": "Votre serveur de stockage a refusé d'enregistrer le fichier. Contactez votre administrateur.",
                "network": "Le service client est injoignable. Vérifiez votre connexion et réessayez.",
                "unknown": "Le téléversement a échoué. Réessayez."
            }
        }
    },
    "bastion": {
        "pending": {
            "title": "La clé de connexion sécurisée est en attente d'approbation",
            "message": "Votre appareil a demandé l'accès. Un administrateur doit l'approuver avant que vous puissiez continuer."
        },
        "revoked": {
            "title": "L'accès a été révoqué par un administrateur",
            "message": "L'accès de cet appareil a été révoqué. Contactez votre administrateur Privanot pour le rétablir."
        },
        "rejected": {
            "title": "La demande de clé de connexion sécurisée a été rejetée",
            "message": "La demande d'accès de cet appareil a été rejetée. Contactez votre administrateur Privanot ou configurez une nouvelle clé."
        },
        "conflict": {
            "title": "Clé de connexion sécurisée déjà utilisée",
            "message": "Cette clé de connexion sécurisée est déjà enregistrée pour un autre client et ne peut pas être utilisée. Contactez votre administrateur Privanot."
        },
        "none": {
            "title": "Aucune clé de connexion sécurisée configurée",
            "message": "Cet appareil n'a pas de clé de connexion sécurisée. Contactez votre administrateur Privanot pour terminer la configuration."
        },
        "checkAgain": "Vérifier à nouveau"
    },
    "tunnel": {
        "reconnectingAttempt": "Reconnexion… (tentative {{attempt}})",
        "reason": {
            "auth_rejected": "Le bastion a rejeté la clé de connexion de cet appareil.",
            "host_key_mismatch": "L'identité du bastion Privanot n'a pas pu être vérifiée.",
            "invalid_config": "La connexion sécurisée est mal configurée.",
            "port_in_use": "Le port de connexion local est déjà utilisé.",
            "unreachable": "Impossible de joindre le bastion Privanot.",
            "retries_exhausted": "Impossible de se connecter au bastion Privanot après plusieurs tentatives."
        }
    },
    "auth": {
        "signIn": {
            "title": "Connexion à Privanot",
            "subtitle": "Utilisez le compte Microsoft de votre organisation.",
            "button": "Se connecter avec Microsoft",
            "inProgress": "Terminez la connexion dans votre navigateur…",
            "cancel": "Annuler",
            "retry": "Réessayer"
        },
        "errors": {
            "unreachable": "La connexion Microsoft est inaccessible depuis votre réseau. Veuillez contacter votre service informatique.",
            "accessDenied": "Accès refusé. Votre compte n'est pas autorisé à utiliser Privanot. Veuillez contacter votre service informatique.",
            "tokenVersion": "La connexion Microsoft à Privanot n'est pas configurée correctement (l'inscription d'application doit émettre des jetons v2). Veuillez contacter votre service informatique.",
            "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
            "serviceUnavailable": "Impossible de joindre le service Privanot.",
            "unknown": "La connexion a échoué. Veuillez réessayer.",
            "sessionExpiredDuringRun": "Votre session a expiré pendant le traitement des fichiers. Le fichier en cours se termine et les fichiers restants échouent. Reconnectez-vous et utilisez Réessayer pour les fichiers en échec."
        },
        "browserPage": {
            "success": "Connexion réussie. Vous pouvez fermer cet onglet et revenir à Privanot.",
            "error": "La connexion a échoué. Vous pouvez fermer cet onglet et revenir à Privanot."
        },
        "signOutConfirm": {
            "title": "Se déconnecter pendant un envoi ?",
            "message": "Une opération est en cours. Si vous vous déconnectez maintenant, le fichier en cours sera terminé, mais les fichiers restants échoueront.",
            "confirm": "Se déconnecter",
            "cancel": "Rester connecté"
        },
        "unavailable": {
            "title": "Privanot n'est pas disponible pour le moment"
        }
    }
}
